function Main() {
  return (
    <div>
      <h1>Welcome to Doha coffee admin dashbord MF</h1>
    </div>
  );
}

export default Main;
